import React from 'react';
import { Text, Heading } from '@aws-amplify/ui-react';

const Introduction = (props) => {
    return (
        <>
            <Heading level={2}>Meine Rehaziele</Heading>
            <Text>
                Bitte nehmen Sie sich Zeit und füllen diesen Bogen sorgfältig aus.<br /><br />
                Es ist wichtig, dass Sie sich vor Antritt der Reha bereits zuhause Gedanken machen, welche Ziele Sie bis zum Ende der Reha erreichen möchten. 
                Was soll sich für Sie verändern? Was soll Ihnen besser gelingen? Worüber möchten Sie mehr erfahren?
                Auf der Basis Ihrer <u>persönlichen Ziele</u> für die Reha wird Ihr Therapieplan mit Ihnen auf <u>Ihre Bedürfnisse</u> angepasst. 
                Diese Ziele sollten möglichst <b>konkret</b> formuliert und <b>realistisch</b> während der Reha zu erreichen sein. 
                Nur so können wir bestmöglich zum Erfolg Ihrer Reha beitragen.<br /><br />
                Beginnen Sie bitte mit dem Ausfüllen der linken Spalte. Am Ende bewerten Sie Ihre Ziele nach Wichtigkeit. 
                Dies wird Ihnen helfen, Ihre drei wichtigsten Ziele in eigenen Worten auf der nächsten Seite zu formulieren.<br />&nbsp;
            </Text>
        </>
    );
}

export default Introduction;